import React from "react";
import { LoadingSpinner } from "./LoadingSpinner";
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onSearchSubmit?: () => void;
  isLoading?: boolean;
  placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  searchQuery,
  onSearchChange,
  onSearchSubmit,
  isLoading = false,
  placeholder = "Search...",
}) => {
  return (
    <div className="w-full">
      <div className="flex items-center w-full">
        <div className="relative flex-grow">
          <input
            type="text"
            placeholder={placeholder}
            className="w-full pl-3 pr-12 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50 dark:bg-gray-800 text-gray-800 dark:text-gray-200"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && onSearchSubmit) {
                e.preventDefault();
                onSearchSubmit();
              }
            }}
          />

          {/* Loading spinner */}
          {isLoading && (
            <div className="absolute right-9 top-2.5">
              <LoadingSpinner size="sm" />
            </div>
          )}

          {/* Clear button */}
          {searchQuery && (
            <button
              onClick={() => onSearchChange("")}
              className="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600 dark:text-gray-300 dark:hover:text-white"
              aria-label="Clear search"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          )}
        </div>

        {/* Search button */}
        {onSearchSubmit && (
          <button
            onClick={onSearchSubmit}
            className="ml-2 bg-blue-600 hover:bg-blue-700 text-white p-2 rounded"
            aria-label="Execute search"
          >
            <MagnifyingGlassIcon className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar;
